import { SurveyDefinition } from '../types/survey.types';
import { SurveyStatusAction } from '../hooks/useSurveys';

export type SurveyState = 'draft' | 'active' | 'paused' | 'closed';

/**
 * Derive lifecycle state from the (isActive, launchedAt, closedAt) tuple.
 * Single source of truth — do NOT add a redundant `status` field on the doc.
 *
 *   Draft   = !isActive && !launchedAt
 *   Active  =  isActive
 *   Paused  = !isActive &&  launchedAt && !closedAt
 *   Closed  = !isActive &&                closedAt
 */
export function getSurveyState(
  s: Pick<SurveyDefinition, 'settings' | 'launchedAt' | 'closedAt'>
): SurveyState {
  if (s.settings?.isActive) return 'active';
  if (s.closedAt) return 'closed';
  if (s.launchedAt) return 'paused';
  return 'draft';
}

/** Buttons to show on the dashboard row for each state. Order matters. */
export function availableActions(state: SurveyState): SurveyStatusAction[] {
  switch (state) {
    case 'draft':  return ['activate'];
    case 'active': return ['pause', 'close'];
    case 'paused': return ['resume', 'close'];
    case 'closed': return ['reopen'];
  }
}

export function actionLabel(action: SurveyStatusAction): string {
  switch (action) {
    case 'activate': return 'Activate';
    case 'pause':    return 'Pause';
    case 'resume':   return 'Resume';
    case 'close':    return 'Close';
    case 'reopen':   return 'Reopen';
  }
}

export function stateLabel(state: SurveyState): string {
  switch (state) {
    case 'draft':  return 'Draft';
    case 'active': return 'Active';
    case 'paused': return 'Paused';
    case 'closed': return 'Closed';
  }
}
